module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceConcludedEventsRenderModule",
    "path": "front/piece-concluded-events-render.module"
  },
  "definition": {
    "type": "concludedEvents",
    "name": "PieceConcludedEventsDefinition",
    "group": "Components",
    "availablePlatforms": ["web", "apps"],
    "description": "Concluded Events",
    "isNew": true,
    "fields": [
      {
        "label": "Imagen",
        "type": "groupCollapsable",
        "flattenFields": true,
        "isFolded": false,
        "fields":[
         {
          "name": "Image",
          "type": "linkedImages",
          "mandatory": true
         },
         {
          "name": "preloadImage",
          "label": "Precargar imagen en SSR",
          "type": "boolean",
          "defaultValue": false,
          "isExcluded": true
         },
        ]
      },
      {
        "name": "title",
        "label": "Título",
        "placeholder": "Título del evento",
        "type": "plainText",
        "mandatory": false,
        "defaultValue": "{{collection.title}}"
      },
      {
        "name": "location",
        "label": "Localización",
        "placeholder": "Localización del evento",
        "type": "plainText",
        "mandatory": false,
        "defaultValue": "{{collection.locationname}}"
      },
      {
        "name": "description",
        "label": "Descripción",
        "placeholder": "Descripción del evento",
        "type": "richText",
        "mandatory": false,
        "defaultValue": "{{collection.description}}"
      },
      {
        "name": "extraText",
        "label": "Texto extra",
        "type": "plainText",
        "mandatory": false,
        "defaultValue": "{{collection.extratext}}"
      },
      {
        "name": "date",
        "label": "Fecha",
        "type": "plainText",
        "mandatory": false,
        "defaultValue": "{{collection.date}}"
      },
      {
        "name": "benefitId",
        "label": "ID de evento",
        "type": "plainText",
        "mandatory": false,
        "defaultValue": "{{collection.benefitid}}"
      },
      {
        "label": "Galería",
        "type": "groupCollapsable",
        "flattenFields": true,
        "isFolded": false,
        "fields":[
          {
           "name": "galleryId",
           "label": "Id de galería",
           "type": "plainText",
           "mandatory": false,
           "defaultValue": "{{collection.gallerycollectionid}}"
          },
          {
            "name": "galleryLink",
            "label": "Link de galería",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{collection.linkgallery}}"
          },
          {
            "name": "galleryCtaText",
            "label": "CTA de galería",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{collection.ctagallery}}"
          },
        ]
      }
    ]
  }
};